import React, { useState, useEffect } from 'react';
import './start-of-day.css';
import { goBack, goToScreen, goToScreenAndReset } from '../../actions/router';
import { connect } from 'react-redux';
import { MAIN_GAME_SCREEN, SETTINGS_SCREEN } from '../../constants/routes';
import { IconButton } from '../../components/icon-button';
import { Panel } from '../../components/panel';
import { Heading } from '../../components/heading';
import { TextButton } from '../../components/text-button';
import { Icon } from '../../components/icon';
import { Paragraph } from '../../components/paragraph';
import classNames from 'classnames';
import { logAnalyticsEvent } from '../../helpers/analytics';

const days = [
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
    'sunday',
];

const StartOfDayScreen = props => {
    const { day, goBack, goToSettings, continueToDay } = props;

    const [unlockedTextHidden, setUnlockedTextHidden] = useState(true);

    useEffect(() => {
        const unlockedTextTimeout = setTimeout(
            () => setUnlockedTextHidden(false),
            300,
        );
        return () => clearTimeout(unlockedTextTimeout);
    });

    const unlockedTextClasses = classNames({
        'start-of-day__unlocked': true,
        'start-of-day__unlocked--hidden': unlockedTextHidden,
    });

    return (
        <div className="start-of-day">
            <IconButton
                iconName="back"
                type="essential"
                size="small"
                onClick={() => goBack()}
                withSpacing={true}
            />
            <Panel
                flexDirection="column"
                currentPage="start of day"
                withPadding
            >
                <div>
                    <Heading
                        headingType="h3"
                        colorScheme="dark"
                        withSpacing={false}
                    >
                        {days[day]}
                    </Heading>
                </div>
                {day !== 0 && day !== 4 && (
                    <div className="start-of-day__unlocked-container">
                        <div className={unlockedTextClasses}>
                            <Paragraph withSpacing={false} colorScheme="dark">
                                {'Unlocked: '}
                                {day === 1
                                    ? 'Meetings'
                                    : day === 2
                                    ? 'Debate'
                                    : 'Inquiry'}
                            </Paragraph>
                        </div>
                    </div>
                )}
                <Icon iconName="start-of-day" size="x-large" />
                <div>
                    <TextButton
                        onClick={() => {
                            continueToDay();
                            logAnalyticsEvent('story-mode-started');
                        }}
                        text="Start"
                    />
                </div>
            </Panel>
            <IconButton
                iconName="settings"
                type="essential"
                size="small"
                onClick={goToSettings}
                withSpacing={true}
            />
        </div>
    );
};

const mapStateToProps = state => {
    return {
        day: state.activeGame.currentDay,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        goBack: () => {
            dispatch(goBack());
        },
        continueToDay: () => {
            dispatch(goToScreenAndReset(MAIN_GAME_SCREEN));
        },
        goToSettings: () => {
            dispatch(goToScreen(SETTINGS_SCREEN));
        },
    };
};

const connected = connect(
    mapStateToProps,
    mapDispatchToProps,
)(StartOfDayScreen);
export { connected as StartOfDayScreen };
